import React from "react";

import AccountBoxIcon from "@mui/icons-material/AccountBox";
import ArrowCircleUpIcon from "@mui/icons-material/ArrowCircleUp";
import WifiIcon from "@mui/icons-material/Wifi";

import {
  AppsIcon,
  LeaderBoardIcon,
  LiveTvIcon,
  ManageAccountsIcon,
} from "veneer/SvgIcon";

import type { NavItemData } from "./NavBar";
import { ROUTE_IDS } from "./routeIds";

export const getZeusRouteItems = (): NavItemData[] => {
  return [
    {
      icon: <AccountBoxIcon />,
      id: ROUTE_IDS.Accounts,
      label: "Accounts",
      matchingPaths: [
        "/accounts/:action(create)",
        "/accounts/:id([0-9]+)/:action(edit)",
        "/accounts/:id",
      ],
      route: "/accounts",
    },
    {
      icon: <WifiIcon />,
      id: ROUTE_IDS.ConnectionAttempts,
      label: "Connection Attempts",
      route: "/connection-attempts",
    },
    {
      icon: <AppsIcon />,
      id: ROUTE_IDS.AppVersions,
      label: "App Versions",
      matchingPaths: ["/networks/app_versions/:action(create)"],
      route: "/networks/app_versions",
    },
    {
      icon: <ArrowCircleUpIcon />,
      id: ROUTE_IDS.WatchdogVersions,
      label: "Watchdog Versions",
      matchingPaths: ["/watchdog_versions/:action(create)"],
      route: "/watchdog_versions",
    },
    {
      children: [
        {
          id: ROUTE_IDS.PlayerReleaseManagementConduct,
          label: "Conduct Release",
          route: "/player/release",
        },
        {
          id: ROUTE_IDS.PlayerReleaseManagementDeviceDistribution,
          label: "Device Distribution",
          route: "/player/device-distribution",
        },
        {
          id: ROUTE_IDS.PlayerReleaseManagementHistory,
          label: "Release History",
          route: "/player/release-history",
        },
      ],
      icon: <LiveTvIcon />,
      id: ROUTE_IDS.PlayerReleaseManagement,
      label: "Player Release Management",
      route: "/player/release",
    },
    {
      children: [
        {
          id: ROUTE_IDS.ReportsAccountDevices,
          label: "Account Devices",
          matchingPaths: [
            "/reports/devices/:accountId(\\d+)/:startDate(\\d{4}-\\d{2}-\\d{2})",
          ],
          route: "/reports/devices",
        },
        {
          id: ROUTE_IDS.ReportsActiveDevices,
          label: "Active Device Count",
          matchingPaths: [
            "/reports/devices/all/:startDate(\\d{4}-\\d{2}-\\d{2})",
          ],
          route: "/reports/devices/all",
        },
      ],
      icon: <LeaderBoardIcon />,
      id: ROUTE_IDS.Reports,
      label: "Reports",
      route: "/reports/devices",
    },
    {
      children: [
        {
          id: ROUTE_IDS.UsersAccounts,
          label: "Account Users",
          matchingPaths: ["/users/account/:id([0-9]+)/edit"],
          route: "/users/account",
        },
        {
          id: ROUTE_IDS.UsersSystem,
          label: "System Users",
          route: "/users/system",
        },
      ],
      icon: <ManageAccountsIcon />,
      id: ROUTE_IDS.Users,
      label: "Users",
      route: "/users/account",
    },
  ];
};
